// @ts-nocheck
import { useState, useEffect } from 'react'
import { useApi } from '../hooks/useApi'

export default function GroupsPage() {
  const [groups, setGroups] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [modalMode, setModalMode] = useState(null) // null | 'create' | 'edit'
  const [editingGroup, setEditingGroup] = useState(null)
  const [showMembersModal, setShowMembersModal] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [groupMembers, setGroupMembers] = useState([])
  const api = useApi()

  useEffect(() => {
    loadGroups()
    loadUsers()
  }, [])

  const loadGroups = async () => {
    try {
      setLoading(true)
      const response = await api.get('/api/groups')
      setGroups(response.items || [])
    } catch (error) {
      console.error('グループ一覧取得エラー:', error)
    } finally {
      setLoading(false)
    }
  }

  const loadUsers = async () => {
    try {
      const response = await api.get('/api/users')
      setUsers(response.items || [])
    } catch (error) {
      console.error('ユーザー一覧取得エラー:', error)
    }
  }

  const openCreateModal = () => {
    setEditingGroup(null)
    setModalMode('create')
  }

  const openEditModal = (group) => {
    setEditingGroup(group)
    setModalMode('edit')
  }

  const closeModal = () => {
    setModalMode(null)
    setEditingGroup(null)
  }

  const handleSaveGroup = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const groupName = formData.get('groupName')
    const description = formData.get('description')

    try {
      if (modalMode === 'edit' && editingGroup) {
        await api.put(`/api/groups/${editingGroup.groupId}`, { groupName, description })
      } else {
        await api.post('/api/groups', { groupName, description })
      }
      closeModal()
      loadGroups()
    } catch (error) {
      console.error('グループ保存エラー:', error)
      alert(modalMode === 'edit' ? 'グループの更新に失敗しました' : 'グループの作成に失敗しました')
    }
  }

  const handleDeleteGroup = async (groupId) => {
    if (!confirm('このグループを削除してもよろしいですか？')) return

    try {
      await api.delete(`/api/groups/${groupId}`)
      loadGroups()
    } catch (error) {
      console.error('グループ削除エラー:', error)
      alert('グループの削除に失敗しました')
    }
  }

  const handleManageMembers = async (group) => {
    setSelectedGroup(group)
    setShowMembersModal(true)
    try {
      const response = await api.get(`/api/groups/${group.groupId}/members`)
      setGroupMembers(response.items || [])
    } catch (error) {
      console.error('メンバー一覧取得エラー:', error)
    }
  }

  const handleAddMember = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const userId = formData.get('userId')

    if (!userId) return

    try {
      await api.post(`/api/groups/${selectedGroup.groupId}/members`, { userId })
      const response = await api.get(`/api/groups/${selectedGroup.groupId}/members`)
      setGroupMembers(response.items || [])
      e.target.reset()
      loadGroups() // メンバー数を更新
    } catch (error) {
      console.error('メンバー追加エラー:', error)
      alert('メンバーの追加に失敗しました')
    }
  }

  const handleRemoveMember = async (membershipId) => {
    if (!confirm('このメンバーをグループから削除してもよろしいですか？')) return

    try {
      await api.delete(`/api/groups/${selectedGroup.groupId}/members/${membershipId}`)
      const response = await api.get(`/api/groups/${selectedGroup.groupId}/members`)
      setGroupMembers(response.items || [])
      loadGroups() // メンバー数を更新
    } catch (error) {
      console.error('メンバー削除エラー:', error)
      alert('メンバーの削除に失敗しました')
    }
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-500">読み込み中...</div>
      </div>
    )
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">オペレータグループ</h1>
        <button
          onClick={openCreateModal}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          グループ作成
        </button>
      </div>

      {groups.length === 0 ? (
        <div className="text-center py-12 text-gray-500">
          グループが作成されていません
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {groups.map((group) => (
            <div key={group.groupId} className="border rounded-lg p-4 bg-white shadow">
              <h3 className="text-lg font-semibold mb-2">{group.groupName}</h3>
              {group.description && (
                <p className="text-gray-600 text-sm mb-4">{group.description}</p>
              )}
              <div className="flex items-center justify-between">
                <span className="text-sm text-gray-500">
                  メンバー: {group.memberCount || 0}人
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleManageMembers(group)}
                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    メンバー管理
                  </button>
                  <button
                    onClick={() => openEditModal(group)}
                    className="px-3 py-1 text-sm bg-gray-500 text-white rounded hover:bg-gray-600"
                  >
                    編集
                  </button>
                  <button
                    onClick={() => handleDeleteGroup(group.groupId)}
                    className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                  >
                    削除
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* グループ作成・編集モーダル */}
      {modalMode && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">
              {modalMode === 'edit' ? 'グループ編集' : 'グループ作成'}
            </h2>
            <form onSubmit={handleSaveGroup} key={editingGroup?.groupId ?? 'new'}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">
                  グループ名 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="groupName"
                  required
                  defaultValue={editingGroup?.groupName ?? ''}
                  className="w-full border rounded px-3 py-2"
                  placeholder="例: 営業部"
                />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-2">説明</label>
                <textarea
                  name="description"
                  defaultValue={editingGroup?.description ?? ''}
                  className="w-full border rounded px-3 py-2"
                  rows="3"
                  placeholder="グループの説明（オプション）"
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={closeModal}
                  className="px-4 py-2 border rounded hover:bg-gray-100"
                >
                  キャンセル
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  {modalMode === 'edit' ? '保存' : '作成'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* メンバー管理モーダル */}
      {showMembersModal && selectedGroup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">
              {selectedGroup.groupName} - メンバー管理
            </h2>

            {/* メンバー追加フォーム */}
            <div className="mb-6 p-4 bg-gray-50 rounded">
              <h3 className="font-semibold mb-3">メンバー追加</h3>
              <form onSubmit={handleAddMember} className="flex gap-2">
                <select
                  name="userId"
                  required
                  className="flex-1 border rounded px-3 py-2"
                >
                  <option value="">ユーザーを選択</option>
                  {users
                    .filter(
                      (user) =>
                        !groupMembers.some((member) => member.userId === user.userId)
                    )
                    .map((user) => (
                      <option key={user.userId} value={user.userId}>
                        {user.displayName || user.email}
                      </option>
                    ))}
                </select>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  追加
                </button>
              </form>
            </div>

            {/* メンバー一覧 */}
            <div>
              <h3 className="font-semibold mb-3">
                現在のメンバー ({groupMembers.length}人)
              </h3>
              {groupMembers.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  メンバーがいません
                </div>
              ) : (
                <div className="space-y-2">
                  {groupMembers.map((member) => (
                    <div
                      key={member.membershipId}
                      className="flex items-center justify-between p-3 border rounded"
                    >
                      <div>
                        <div className="font-medium">{member.displayName}</div>
                        <div className="text-sm text-gray-500">{member.email}</div>
                      </div>
                      <button
                        onClick={() => handleRemoveMember(member.membershipId)}
                        className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                      >
                        削除
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowMembersModal(false)}
                className="px-4 py-2 border rounded hover:bg-gray-100"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
